import { Widget } from '../../core/Widget.js';
import { DEFAULT_NS, executeOnItems } from '../../core/imcmd/types.js';
import { TABLE_NS, TABLE_WIDGET_KEY } from './ITableWidget.js';

// src/widgets/table/TableUiCommandProvider.ts
/**
 * Табличные команды
 */
class TableUiCommandProvider {
    constructor() {
        /** Уникальный идентификатор провайдера */
        this.id = 'TableWidget';
        this.defaultNSAllowed = true;
        this.defaultNDPriority = 20;
        /**
         * Поддерживаемые алиасы пространства имён.
         * Оставляем оба — для совместимости с легаси и нового синтаксиса.
         */
        this.namespace = TABLE_NS;
    }
    /**
     * Исполняет табличную команду.
     * Возвращает:
     *  - false — команда не поддерживается этим провайдером;
     *  - true  — команда обработана (результат не требуется).
     */
    execute(token, ctx) {
        // Защита от «чужих» namespace (на случай ручного вызова)
        const ns = (token.namespace ?? '').toLowerCase();
        if (ns !== 'table' && ns !== DEFAULT_NS)
            return false;
        const cmd = token.command.toLowerCase();
        // Обработка переданных элементов
        return executeOnItems(token, ctx, (el) => {
            const table = Widget.getOnByName(el, TABLE_WIDGET_KEY);
            if (!table)
                return false;
            switch (cmd) {
                default:
                    return false;
            }
        });
    }
}

export { TableUiCommandProvider };
